import { createReducer, on } from '@ngrx/store';

import { IPublicSpecialtyColdChainState } from './interfaces/public-cold-chain.interface';
import {
  SetPublicSpecialtyColdChainScheduling,
  SetPublicSpecialtyColdChainSupply,
  SetPublicSpecialtyColdChainContentsInsurance,
  SetPublicSpecialtyColdChainDangerousGoods,
  SetPublicSpecialtyColdChainContents,
} from './public-cold-chain.actions';

export const publicColdChainInitialState: IPublicSpecialtyColdChainState = {
  scheduling: {
    value: {
      pickedUpSpecificTime: false,
      arriveBySpecificDate: false,
    },
    valid: true,
  },
  contents: {
    value: [],
    valid: false,
    actionType: 'DETAIL',
  },
  supply: {
    value: {},
    valid: false,
  },
  dangerousGoods: {
    value: {
      isFrozenModified: false,
    },
    valid: true,
  },
};

export const publicSpecialtyColdChainReducer = createReducer(
  publicColdChainInitialState,
  on(SetPublicSpecialtyColdChainScheduling, (state, { valid, value }) => {
    return {
      ...state,
      scheduling: {
        value,
        valid,
      },
    };
  }),
  on(
    SetPublicSpecialtyColdChainContents,
    (state, { valid, value, actionType }) => {
      return {
        ...state,
        contents: {
          value,
          valid,
          actionType,
        },
      };
    }
  ),
  on(SetPublicSpecialtyColdChainContentsInsurance, (state, { value }) => {
    return {
      ...state,
      contents: {
        ...state.contents,
        value,
      },
    };
  }),
  on(SetPublicSpecialtyColdChainDangerousGoods, (state, { valid, value }) => {
    return {
      ...state,
      dangerousGoods: {
        value,
        valid,
      },
    };
  }),
  on(SetPublicSpecialtyColdChainSupply, (state, { valid, value }) => {
    return {
      ...state,
      supply: {
        value,
        valid,
      },
    };
  })
);
